import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  paper: {
    margin: "auto",
    padding: theme.spacing(2),
  },
  speakerPreviewContainer: {
    display: "flex",
  },
  speakerPreview: {
    margin: "auto",
    position: "relative",
  },
  progress: {
    position: "absolute",
    top: -10,
    left: -10,
    zIndex: 2,
  },
  icon: {
    fontSize: 80,
  },
  formControl: {
    marginTop: theme.spacing(2),
  },
}));
